export const initialState = ({
  cellphoneNumber,
  emailAddress,
  address,
} = {}) => ({
  cellphoneNumber,
  emailAddress,
  address,
});

export const types = {
  SET_CELLPHONE_NUMBER: 'SET_CELLPHONE_NUMBER',
  SET_EMAIL: 'SET_EMAIL',
  SET_ADDRESS: 'SET_ADDRESS',
};

export const reducer = (state, { type, payload }) => {
  switch (type) {
    case types.SET_CELLPHONE_NUMBER:
      return { ...state, cellphoneNumber: payload };
    case types.SET_EMAIL:
      return { ...state, emailAddress: payload };
    case types.SET_ADDRESS:
      return { ...state, address: payload };
    default:
      throw new Error();
  }
};
